import { useState, useEffect } from "react";
import { apiFetch } from "../../../context/AuthContext";

const CACHE_PREFIX = "modulePermissions:";

export function useModulePermissions(BASE_URL, profile) {
  const clientName =
    profile?.clientName || localStorage.getItem("clientName") || "";

  // Start from the session cache so re-mounts (e.g. switching back from the
  // user profile view) render immediately instead of flashing a blank page.
  const [modulePermissions, setModulePermissions] = useState(() => {
    if (!clientName) return null;
    try {
      const raw = sessionStorage.getItem(CACHE_PREFIX + clientName);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  });
  const [loadingPermissions, setLoadingPermissions] = useState(
    modulePermissions === null
  );

  useEffect(() => {
    const fetchModulePermissions = async () => {
      try {
        if (!clientName) {
          setLoadingPermissions(false);
          return;
        }

        const response = await apiFetch(
          `${BASE_URL}/api/configurations/${encodeURIComponent(clientName)}`,
          { method: "GET" },
        );
        const json = await response.json();

        const data = json && json.data != null ? json.data : { privateMessaging: false };
        setModulePermissions(data);
        try {
          sessionStorage.setItem(CACHE_PREFIX + clientName, JSON.stringify(data));
        } catch (e) {
          // Ignore quota/serialization errors — cache is an optimization only
        }
      } catch (error) {
        console.error("Error fetching module permissions:", error);
        setModulePermissions((prev) => prev || { privateMessaging: false });
      } finally {
        setLoadingPermissions(false);
      }
    };

    fetchModulePermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { modulePermissions, loadingPermissions };
}
